import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Table, TableBody, Typography, withStyles } from '@material-ui/core';
import { ROLE_USER } from '../../constants/roles';
import BookingsTableHead from './BookingsTableHead';
import BookingsRow from './BookingsRow';
import Loader from '../Layout/Loader';
//import KobooTablePagination from '../Layout/KobooTablePagination';

const styles = () => (
  {
    table: {
      minWidth: 700,
    },
    fabProgress: {
      color: 'primary',
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
    },
    paperTab: { width: '60%' },
  }
);

export class BookingsTable extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      order: 'desc',
      orderBy: 'date',
      data: [],
      page: 0,
      rowsPerPage: 500,
      role: ROLE_USER,
      selectedTab: 0,
    };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.role) {
      newState = {
        ...newState,
        role: props.role[props.authUser.uid],
      };
    }
    if (props.books) {
      let selectedData = props.books;
      newState = {
        ...newState,
        data: selectedData.sort((a, b) => BookingsTable.sort(a,
          b,
          state.orderBy,
          state.order,
        )),
      };
    }
    return newState;
  }

  static sort(a, b, property, order) {
    let prop1,
      prop2;
    if (property === 'client_name') {
      prop1 = (
        a.username !== null && a.username !== undefined
      )
        ? a.username.toUpperCase()
        : '';
      prop2 = (
        b.username !== null && b.username !== undefined
      )
        ? b.username.toUpperCase()
        : '';
    } else {
      prop1 = (
        a[property] !== null && a[property] !== undefined
      )
        ? a[property]
        : -1;
      prop2 = (
        b[property] !== null && b[property] !== undefined
      )
        ? b[property]
        : -1;
    }
    if (order === 'asc') {
      return prop1 > prop2
        ? -1
        : 1;
    }
    return prop1 < prop2
      ? -1
      : 1;
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === orderBy && this.state.order === order) {
      order = 'asc';
    }
    const data = this.state.data.sort((a, b) => BookingsTable.sort(a, b, orderBy, order));
    this.setState({
      data,
      order,
      orderBy,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const {
      classes,
      books,
      pending,
    } = this.props;

    const {
      rowsPerPage,
      page,
      data,
      order,
      orderBy,
    } = this.state;

    return (
      <div>
        <Table className={classes.table}>
          <BookingsTableHead
            onRequestSort={this.handleRequestSort}
            order={order}
            orderBy={orderBy}
            rowCount={books
              ? books.length
              : 0}
          />
          <TableBody>
            {pending && <tr>
              <td colSpan={5}>
                <Loader />
              </td>
            </tr>}
            {!pending && books && books.length > 0
            && data.slice(
              page * rowsPerPage,
              (
                page * rowsPerPage
              ) + rowsPerPage,
            ).map(book => (
              <BookingsRow
                key={book.id}
                book={book}
              />
            ))}
            {!pending && books && books.length <= 0 &&
            <tr>
              <td colSpan={5}>
                <Typography style={{ textAlign: 'center' }} variant="subtitle1">
                  Aucune réservation
                </Typography>
              </td>
            </tr>
            }
          </TableBody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
  };
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(BookingsTable);



// WEBPACK FOOTER //
// ./src/components/Bookings/BookingsTable.jsx